import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Ordre personnalisé des pages du menu et des sections de chaque page (enregistré côté serveur)
let cache = null;
let promesse = null;
const abonnes = new Set();
const notifier = () => abonnes.forEach((f) => f(cache));

export const chargerDisposition = () => {
  if (!promesse) {
    promesse = api.get("/disposition")
      .then((r) => { cache = r.data; notifier(); return cache; })
      .catch(() => { cache = { menu: [], sections: {} }; promesse = null; notifier(); return cache; });
  }
  return promesse;
};

export const useDisposition = () => {
  const [d, setD] = useState(cache);
  useEffect(() => {
    abonnes.add(setD);
    chargerDisposition();
    return () => { abonnes.delete(setD); };
  }, []);
  return d;
};

export const cleSections = (page) => page.replace(/\./g, "_");

export const enregistrerMenu = async (ordre) => {
  cache = { ...(cache || { sections: {} }), menu: ordre };
  notifier();
  await api.put("/disposition/menu", { ordre });
};

export const enregistrerSections = async (page, ordre) => {
  const sections = { ...(cache?.sections || {}), [cleSections(page)]: ordre };
  cache = { ...(cache || { menu: [] }), sections };
  notifier();
  await api.put("/disposition/sections", { page, ordre });
};

export const ordonner = (items, ordre, cle) => {
  const rang = new Map(ordre.map((k, i) => [k, i]));
  return items.map((x, i) => [x, i])
    .sort((a, b) => (rang.get(cle(a[0])) ?? 1e6 + a[1]) - (rang.get(cle(b[0])) ?? 1e6 + b[1]))
    .map(([x]) => x);
};

export const deplacer = (liste, i, j) => {
  const l = [...liste];
  const [x] = l.splice(i, 1);
  l.splice(Math.max(0, Math.min(l.length, j)), 0, x);
  return l;
};
